export const BASE_API_URL = "https://dev.api.vlc-control.idc.md";
// export const BASE_API_URL = "https://api.vlc-control.idc.md";

// номер версии с датой
export const version = "4.4.2 от 27.04.2026";
